/* eslint-disable camelcase */
/** 广告系统组件 事件返回对象 */
export interface AdvEvent {
    type: AdvEventTypes;
    data: {
        impid: string;
        customClick: boolean;
        dataset: AdvDataset;
        /** 当前点击事件的详细值 */
        'bus-info'?: advEventBusInfo;
        'dsl-shttp-config'?: {
            'success-action': string;
        };
    }
}

/**
 * 事件类型
 * */
export enum AdvEventTypes {
    /** 组件展示时 */
    ONLOAD = 'onLoad',
    /** 组件点击时 */
    ONCLICK = 'onClick',
    /** 组件弹窗关闭时 */
    ONCLOSE = 'onClose',
}

export interface AdvDataset {
    index: number,
    item: {
        link: string;
        tracker: {
            child_task_id: string;
            child_task_name: string;
            task_id: string;
            task_name: string;
        },
        segment: {
            data: Dictionary<string>
        },
        ext: {
            jumpConfig?: {
                userName: string;
                path: string;
            }
        }
    }
}

export interface advEventBusInfo {
    click_module_name: string,
    url: string
}
